import { useAuthStore } from '../../../stores/authStore';
import { BookingPageSection } from '../../../components/settings/BookingPageSection';
import { SettingsSubPage } from '../components/SettingsSubPage';

export function BookingPageSettingsPage() {
  const authBusiness = useAuthStore(s => s.business);

  return (
    <SettingsSubPage title="Booking page" description="Slug, branding, hero, reviews, embed widget">
      <BookingPageSection
        businessId={authBusiness?.id}
        businessName={authBusiness?.name ?? ''}
      />
    </SettingsSubPage>
  );
}
